import styled, { css } from 'styled-components';
import { colors, remoteHealthColors } from 'style/theme';
import { sizes } from 'style';

export const Search = styled.input`
  display: block;
  width: 100%;
  padding: 16px;
  border-top-right-radius: 32px;
  border-top-left-radius: 32px;
  border-bottom: 1px solid ${colors.transparentWhite[4]};
  color: inherit;
  background-color: ${colors.transparentWhite[2]};
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);

  @media ${sizes.desktop} {
    padding: 20px;
    font-size: 20px;
  }
`;

export const SearchContainer = styled.div`
  position: relative;

  > :last-child {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 26px;
    height: 26px;
  }
`;

export const Placeholder = styled.div`
  position: absolute;
  top: 50%;
  left: 18px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  pointer-events: none;

  @media ${sizes.desktop} {
    font-size: 20px;
    left: 22px;
  }

  > img {
    margin-right: 20px;
    vertical-align: middle;
  }
`;

export const CountryList = styled.div`
  position: relative;
  max-height: 300px;
  overflow: scroll;
  border-bottom-right-radius: 32px;
  border-bottom-left-radius: 32px;
  background-color: ${colors.transparentWhite[2]};
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  z-index: 1;

  @media ${sizes.desktop} {
    max-height: 400px;
  }
`;

export const Country = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;

  @media ${sizes.desktop} {
    font-size: 20px;
    padding: 16px 20px;
  }

  > :first-child {
    margin-right: 20px;
  }

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: ${remoteHealthColors.countrySelect.dropdownHighlight};
    `}
`;

export const NoOptions = styled.div`
  padding: 8px 16px;
  color: ${colors.white};

  @media ${sizes.desktop} {
    padding: 16px 20px;
  }
`;

export const Container = styled.div<{ $selected?: boolean }>`
  color: ${remoteHealthColors.countrySelect.text};

  > ${SearchContainer} > ${Search}, > ${CountryList} {
    background-color: ${remoteHealthColors.countrySelect.dropdown};
  }

  > ${CountryList} > ${Country} {
    :hover {
      background-color: ${remoteHealthColors.countrySelect.dropdownHighlight};
    }
  }
`;
